import React from 'react'
import { ConsentPage } from './ConsentPage'

export const ExperianConsent = () => (
  <ConsentPage serviceName="Experian" servicePath="experian_service" />
)
